<template>
  <div class="details">
    <div >
      <QS-h3-title >
        <template slot="title">应收信息详情</template>
      </QS-h3-title>
    </div>
    <div class="splitline mt16 mb16" />
    <div>
      <QS-h4-title title="应收信息详情" />
      <column-box
        :source="source"
        :list="basisList"
        :column="3"
        :label-width="130"
      ></column-box>
    </div>
    <div>
      <QS-h4-title title="应收业务信息" />
      <column-box
        :source="source"
        :list="businessList"
        :column="3"
        :label-width="130"
      ></column-box>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getSensitiveReceivableDetail } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      basisList: [
        {
          key: 'id',
          name: '应收ID',
        },
        {
          key: 'receivableState',
          name: '收款状态',
        },
        {
          key: 'content',
          name: '收款内容',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'completeTime',
          name: '完成时间',
        },
        {
          key: 'closeTime',
          name: '关闭时间',
        },
        {
          key: 'itemAmount',
          name: '款项金额',
        },
        {
          key: 'relieveAmount',
          name: '减免金额',
        },
        {
          key: 'receivableAmount',
          name: '应收金额',
        },
        {
          key: 'commissionReceivingAmount',
          name: '乾三收款中佣金',
        },
        {
          key: 'commissionReceivedAmount',
          name: '乾三已收款佣金',
        },
        {
          key: 'receivedAmount',
          name: '已收金额',
        },
        {
          key: 'receivableDate',
          name: '应收日期',
        },
      ],
      businessList: [
        {
          key: 'sourceOrderId',
          name: '来源单ID',
        },
        {
          key: 'sourceOrderType',
          name: '来源类型',
        },
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'customer',
          name: '付款方',
        },
        {
          key: 'customerId',
          name: '付款客户ID',
        },
        {
          key: 'purchaseType',
          name: '采购方式',
        },
        {
          key: 'remarks',
          name: '备注',
          alone: true,
        },
      ],
      source: {},
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    const { id } = this.$route.query
    this.getReceivableDetail(id)
  },
  methods: {
    getReceivableDetail(id) {
      getSensitiveReceivableDetail({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.source = {
            ...data,
            receivableAmount: this.numberWithCommas(data.receivableAmount), // 应收金额
            receivedAmount: this.numberWithCommas(data.receivedAmount), // 已收金额
          }
          this.source.receivableState = selectOption.completionStatusDict[data.receivableState]
          this.source.content = this.formatEnumeration(this.freeTypeList)[data.content]
          this.source.sourceOrderType = selectOption.sourceOrderTypeDict[data.sourceOrderType]
        }
      })
    },
  },
}
</script>
